import React from 'react';
import { registryData } from '../../config/registryData';
import { useLastChecks } from '../../hooks/useLastChecks';
import LastCheckItem from './LastCheckItem';

interface RegistryLastCheckProps {
  /** typeGroups rejstříků, pro které je naplánovaná (nedokončená) kontrola. */
  plannedChecks?: string[];
}

const RegistryLastCheck: React.FC<RegistryLastCheckProps> = ({ plannedChecks = [] }) => {
  const { isLoading, lastCheckDates, lastBuildingLogs } = useLastChecks();

  return (
    <>
      {registryData.map((registry) => (
        <LastCheckItem
          key={registry.type}
          registry={registry}
          lastCheckDate={lastCheckDates[registry.type] || 'Není k dispozici'}
          lastLogs={lastBuildingLogs[registry.type]}
          isLoading={isLoading}
          isPlanned={!lastCheckDates[registry.type] && plannedChecks.includes(registry.type)}
        />
      ))}
    </>
  );
};

export default RegistryLastCheck;
